module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAA+UlEQVQoU8WRsUrEQBCG/3+jgoWtsI1voS9wB4KV2GlhY8LE0tLmWLjGynZ3FhuxUgTBQrD0FQTxGQTxDZKVhLsjF7y0TjfzfzPMP0P0wnu/R3KnLMvHrsRuEmMcp5SeAWwCuBSRq7m+AEMIBySfAGx0miciMm3yFlTVQwAPANb7qwCYisiE3vt9ki8kzR9QWyJ5xhjjbl3X41VQU6+q6m3JzBD8n6D3fpvk8ZDrlNIrVfUCwPWQEQCOzrk1a+09gKMV8CeAUevaOWestXcATnrwhzFmVBTF19J5Qgi3JE9n8HszSUS+F7/uTlHVcwBbWZbd5Hn+M9d+AXWHQFrKbVnWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/imgs/mall/default.png
// module id = 1HO6
// module chunks = 1